import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getPostLoginRoute, persistJwtSession } from "../../services/auth";
import { evaluateAndReturn } from "../../Utils/common";
import { Box, Typography, Button, Paper } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CenterLoader from "../../components/loader"

const RedrictURL = ({ setToken }) => {
    const navigate = useNavigate();
    const [userMessage, setUserMessge] = useState("")

    useEffect(() => {
        const hydrateSession = async () => {
            const url = new URL(globalThis.location.href);
            const jwt = url.searchParams.get("token");

            if (jwt) {
                try {
                    const userData = await persistJwtSession(jwt);
                    setToken(jwt);
                    navigate(getPostLoginRoute(userData.rolename));
                } catch (err) {
                    setUserMessge(err?.response?.data?.errorMessages?.[0]?.message || err?.message || "Unable to process login token.");
                }
                return;
            }

            navigate('/dashboard');
        };

        hydrateSession();
    }, [navigate, setToken]);

    const goBack = () => {
        sessionStorage.removeItem('userDtls');
        sessionStorage.removeItem('accessToken');
        navigate('/');
    }

    return <>

        {evaluateAndReturn(userMessage, <Box
            sx={{
                height: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: "background.default",
                px: 2,
            }}
        ><Paper
                elevation={3}
                sx={{
                    p: 4,
                    maxWidth: 400,
                    textAlign: "center",
                    borderRadius: 3,
                }}
            ><ErrorOutlineIcon color="error" sx={{ fontSize: 60, mb: 2 }} /><Typography variant="h5" gutterBottom>
                    User Not Found
                </Typography><Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                    The user you are looking for does not exist or may have been removed.
                </Typography><Button
                    variant="contained"
                    color="primary"
                    onClick={goBack}
                    sx={{ borderRadius: 2, px: 4 }}
                >
                    Go Home
                </Button></Paper></Box>, <CenterLoader text="Fetching user..." />)
        }
    </>
}
export default RedrictURL
 